import { CardContentProps, CardContent as MUICardContent } from "@mui/material";

type Props = { restrictContentWidth?: boolean } & CardContentProps;

export const CardContent = ({ restrictContentWidth = true, sx, children, ...props }: Props) => {
  return (
    <MUICardContent sx={{ maxWidth: (theme) => (restrictContentWidth ? theme.breakpoints.values.lg : "none"), ...sx }} {...props}>
      {children}
    </MUICardContent>
  );
};
